<template>
	<n-config-provider :theme-overrides="themeOverrides">
		<section class="mobile-layout">
			<MHeader v-if="showNav" :sticky="isSticky" :stickyOffset="stickyOffset" />
			<ClientOnly>
				<MLogin
					v-if="showLogin"
					:key="loginPresetVersion"
					v-model="showLogin"
					:backUrl="backUrl"
					:presetData="loginPresetData"
					:trigger-source="loginTriggerSource"
				/>
				<MobileEmailOfficail v-if="showEmailOfficail" v-model="showEmailOfficail" />
				<AppDownloadModal v-if="shouldMountSupportWidgets && !isInAppEnv" />
				<KeFu v-if="shouldMountSupportWidgets && !isConsultRoute && !isInAppEnv" />
			</ClientOnly>
			<main role="main">
				<slot />
			</main>
			<MFooter v-if="showFooter" :lang="pcFooterLang" />
		</section>
	</n-config-provider>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
import MHeader from "~/components/m/header/m-header.vue";
import MFooter from "~/components/footer/m-footer.vue";
import { useSiteShell } from "~/composables/useSiteShell";

const MLogin = defineAsyncComponent(() => import("~/components/m/new-login/m-login.vue"));
const KeFu = defineAsyncComponent(() => import("~/components/kefu/index.vue"));
const MobileEmailOfficail = defineAsyncComponent(
	() => import("~/components/m/email-officail/m-email-officail.vue")
);
const AppDownloadModal = defineAsyncComponent(
	() => import("~/components/m/app-download-modal/index.vue")
);

const {
	pcFooterLang,
	showNav,
	isSticky,
	stickyOffset,
	showFooter,
	isConsultRoute,
	isInAppEnv,
	shouldMountSupportWidgets,
	showLogin,
	loginPresetData,
	loginPresetVersion,
	loginTriggerSource,
	showEmailOfficail,
	backUrl,
	themeOverrides,
} = useSiteShell();
</script>

<style scoped>
.mobile-layout {
	width: 100%;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	overflow-x: hidden;
	overflow-y: scroll;
}

.mobile-layout main[role="main"] {
	position: relative;
	min-height: 100vh;
}
</style>
